import { useTheme } from "@emotion/react";
import {
	Button,
	Chip,
	Paper,
	Rating,
	TextField,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import useStyles from "./styles";
import RatingWoman from "../../../components/artsPersonComponent/ratingWoman";
import PropTypes from "prop-types";
import StyledRatingComponent from "../../styledRatingComponent";
export default function AvaliacaoComponent(params) {
	const { questions } = params;
	const theme = useTheme();
	const styles = useStyles(theme);
	const [selecionados, setSelecionados] = useState([]);
	const toggleSelecionado = (label) => {
		setSelecionados((prevSelecionados) =>
			prevSelecionados.includes(label)
				? prevSelecionados.filter((item) => item !== label)
				: [...prevSelecionados, label]
		);
	};

	return (
		<Paper variant={"outlined"} sx={styles.modal}>
			<RatingWoman
				backgroundFill={theme.palette.tertiary.medium}
				circleFill={theme.palette.background.paper}
			/>

			<Box sx={styles.boxComponent}>
				<Typography sx={{ fontSize: "22px", fontWeight: "bold" }}>
					Deseja avaliar a sua experiência?
				</Typography>
			</Box>
			<Paper variant="outlined" sx={{ overflowY: "auto", height: "330px" }}>
				{Array.isArray(questions) &&
					questions?.length > 0 &&
					questions?.map((question, index) => (
						<Box sx={styles.containerQuestion}>
							<Box sx={styles.containerDescriptionQuestion}>
								<Typography sx={{}}>
									{index + 1} - {question?.question}
								</Typography>
							</Box>

							{question?.type === 0 && <StyledRatingComponent />}

							{question?.type === 1 && (
								<TextField
									sx={{ width: "100%" }}
									id="outlined-multiline-static"
									label="Comentário"
									multiline
									rows={3}
								/>
							)}
							{question?.type === 2 && (
								<Paper variant="outlined" sx={styles.containerChipsSelect}>
									{question?.options?.map((option) => (
										<Chip
											key={option?.option}
											label={option?.option}
											size="small"
											clickable
											onClick={() => toggleSelecionado(option?.option)}
											color={
												selecionados.includes(option?.option)
													? "primary"
													: "default"
											}
											variant={
												selecionados.includes(option?.option)
													? "filled"
													: "outlined"
											}
										/>
									))}
								</Paper>
							)}
						</Box>
					))}
			</Paper>
			<Box sx={styles.containerButtons}>
				<Button variant="text">Não, obrigado</Button>
				<Button variant="contained">Enviar</Button>
			</Box>
		</Paper>
	);
}
